import React from "react";

const CognitoUserContext = React.createContext(null);

export default CognitoUserContext;
